import { FORMAT } from '../lib/env';

export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api';

// Format-specific API prefix
const FORMAT_API = `${API_BASE_URL}/${FORMAT}`;

export const API_ENDPOINTS = {
  discovery: {
    all: `${API_BASE_URL}/discovery/all`,
    plugins: `${API_BASE_URL}/discovery/plugins`,
    documents: `${API_BASE_URL}/discovery/documents`,
    themes: `${API_BASE_URL}/discovery/themes`,
    schemas: {
      document: `${API_BASE_URL}/discovery/schemas/document`,
      theme: `${API_BASE_URL}/discovery/schemas/theme`,
    },
  },
  generate: `${FORMAT_API}/generate`,
  validate: `${FORMAT_API}/validate`,
  diff: `${FORMAT_API}/diff`,
  fonts: {
    catalog: `${API_BASE_URL}/fonts/catalog`,
    materialize: `${API_BASE_URL}/fonts/materialize`,
  },
  preview: {
    libreoffice: `${FORMAT_API}/preview/libreoffice`,
    libreofficeFromJson: `${FORMAT_API}/preview/libreoffice-from-json`,
  },
  renderers: `${FORMAT_API}/renderers`,
  cacheStats: `${FORMAT_API}/cache-stats`,
};
